// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"4e111a55","229":"b5996dad","254":"b8f8eb4c","262":"07291e62","266":"39b1f90e","341":"c44a85b2","381":"039a6a73","453":"0437a03d","521":"32c66461","537":"9ee0ca54","621":"39bf4446","641":"94eeb53b","652":"1b6b3e6f","973":"0bfd2a64"}[chunkId] + ".chunk.js";
};